import { Component, input } from "@angular/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { WkTranslatePipe } from "@shared/utils";
import type { WkDataTableToolbarItems } from "@components/data-table/data-table.types";

@Component({
    selector: "wk-data-table-toolbar",
    templateUrl: "./data-table-toolbar.component.html",
    styleUrl: "./data-table-toolbar.component.scss",
    imports: [WkTranslatePipe, JumpstartComponentsModule],
    host: {
        class: "wk-data-table__toolbar",
    },
})
export class WkDataTableToolbar {
    public title = input<string>("");
    public toolbar = input<WkDataTableToolbarItems>([]);
}
